import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '@/App';
import { toast } from 'sonner';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useContext(AuthContext);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (!sessionId) {
      toast.error('Invalid payment session');
      navigate('/subscription');
      return;
    }

    // Show success message
    toast.success('Payment successful! Processing your subscription...');
    
    // Wait a moment for webhook to process, then refresh user data
    const refreshTimer = setTimeout(async () => {
      await refreshUser();
    }, 2000);
    
    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          navigate('/subscription');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => {
      clearTimeout(refreshTimer);
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-primary)' }}>
      <div className="sketch-border max-w-md p-8 text-center rounded-2xl" style={{ background: 'var(--bg-secondary)' }}>
        <CheckCircle2 className="w-20 h-20 mx-auto mb-6 text-green-500" />
        
        <h2 className="font-heading text-3xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
          Payment Successful!
        </h2>
        
        <p className="text-lg mb-6" style={{ color: 'var(--text-secondary)' }}>
          Thank you for subscribing! Your subscription is being activated.
        </p>
        
        <div className="mb-6 p-4 rounded-lg bg-blue-50">
          <p className="text-sm text-blue-800">
            • Your subscription is now active<br />
            • You'll receive a confirmation email shortly<br />
            • Access all premium features now
          </p>
        </div>
        
        <p className="text-sm mb-4" style={{ color: 'var(--text-secondary)' }}>
          Redirecting in {countdown} seconds...
        </p>
        
        <Button
          onClick={() => navigate('/subscription')}
          className="font-sketch"
        >
          View My Subscription
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;